module.exports = __webpack_public_path__ + "static/media/boy1.cfd7cfc6.svg";